import { PartiStoreService } from '../../Progetti/_services/parti-store.service';
import { environment } from 'src/environments/environment';
import { ApiPathsService } from '../../api-paths.service';
import { FileStoreService } from '../../shared/_services/file-store.service';
import { Delete } from 'angular-feather/icons';
import { Prodotto } from '../../Progetti/Models/Prodotto';
import { ProdottiStoreService } from '../../Progetti/_services/prodotti-store.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service';

@Component({
  selector: 'app-lista-prodotti',
  templateUrl: './lista-parti.component.html',
  styleUrls: ['./lista-parti.component.scss']
})
export class ListaPartiComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  showAllText: string = "Mostra Eliminati"
  showAllUser: boolean = false;
  type=""
  ricercaform: FormGroup;
  submittedricerca;
  collectionSize = 0;
  page = 1;
  pageSize: number = 50;
  pagesizeserver = 4; // pagine da precaricare dal server
  newpagegenerated: number;
  Prodotti: Prodotto[] = [];
  titolo= "menu.PartiLabel"
  constructor(private route: ActivatedRoute,
    public router: Router,
    private progettistore: PartiStoreService,
    private paginationService: ServerPaginationService,
    private formBuilder: FormBuilder,
    private filestore: FileStoreService,
    public apiPaths: ApiPathsService,
  ) {
    this.ricercaform = this.formBuilder.group({
      cerca: [''],
      size:[this.pageSize],
    });

  }
  get f() { return this.ricercaform.controls; }
  ngOnInit() {
    this.progettistore.getCategorieProdotti();
    this.progettistore.getUnitaDiMisura();// TODO: walkaround pe lista unita
    this.route.params.subscribe(data => {
      this.type= data['type'];
      this.refreshTable(1);
    } )
    this.subscriptions.add(this.progettistore.$showAllProdotti.subscribe(data => this.showAllUser = data));
    this.subscriptions.add(this.progettistore.$prodotti.subscribe(data=> {
      this.Prodotti = data.data;
      this.collectionSize = data.total;
    }));
  }

  showDeleted() {
    this.progettistore.updateShowAllProdotti(!this.showAllUser);
    this.refreshTable(1);
    if (this.showAllUser) {
      this.showAllText = "Nascondi eliminati";
    } else {
      this.showAllText = "Mostra eliminati";
    }
  }

  sizeChanged() {
    this.pageSize = parseInt(this.f.size.value);
    this.refreshTable(1);
  }
  Search() {
    this.submittedricerca = true;
    if (this.ricercaform.invalid) { return; }
    this.refreshTable(1);
    this.submittedricerca = false;
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page) {
    console.log('pagina generata',this.newpagegenerated)
    if (this.f.cerca.value != "") {
      this.progettistore.getParti(new Prodotto((page - 1) / this.pagesizeserver +1, this.pagesizeserver * this.pageSize, parseInt(this.type), 'asc', this.f.cerca.value));
    } else {
      this.progettistore.getParti(new Prodotto((page - 1) / this.pagesizeserver +1, this.pagesizeserver * this.pageSize, parseInt(this.type), 'asc'));
    }
  }
  requestdata(page): Prodotto{
    if (this.f.cerca.value != "") {
      return new Prodotto((page - 1) / this.pagesizeserver +1, this.pagesizeserver * this.pageSize, parseInt(this.type), 'asc', this.f.cerca.value);
    } else {
      return new Prodotto((page - 1) / this.pagesizeserver +1, this.pagesizeserver * this.pageSize, parseInt(this.type), 'asc');
    }
  }
  delete(value: Prodotto){
    if(confirm("Sicuro di voler eliminare questo elemento dalla lista?")) {
      this.progettistore.deleteItem(this.requestdata(1), value);
    }
  }
  renew(value) {
    this.progettistore.renewItem(this.requestdata(1), value);
  }
  edit(value) {
    this.progettistore.updateEditable(true);
    this.progettistore.updateShowAddForm(false);
    this.progettistore.updateSelectedProdotto(value);
    this.router.navigate([this.route.snapshot.queryParams['progetti/parti/editor'] || 'progetti/parti/editor',]);
  }
  add(){
    this.progettistore.updateEditable(false);
    this.progettistore.updateShowAddForm(true);
    this.progettistore.updateSelectedProdotto(null);

    this.router.navigate([this.route.snapshot.queryParams['progetti/parti/editor'] || 'progetti/parti/editor',]);
  }
}
